// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my_account_inner {
  background: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  margin-bottom: 40px;
}

.my_account_inner h2 {
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  color: #000;
  margin-bottom: 0px;
}

.my_account_form {
  margin-top: 40px;
}

.accnt_form label {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}
.accnt_form .accnt_field {
  height: 45px;
  border-radius: 6px;
  border: 1px solid #004aad;
  font-size: 14px;
}

.accnt_form .accnt_field:focus {
  outline: 0px;
  box-shadow: none;
}

.accnt_form .accnt_field::placeholder {
  font-size: 14px;
}

.accnt__bg .accnt_field {
  background: #e7e6e6;
}

.accnt_submitt {
  display: block;
  width: 100%;
  background: #004aad;
  border-radius: 6px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  height: 45px;
  line-height: 45px;
  padding: 0;
}

.right_cont .right_banner_banner_cnt .my_account_inner .profile_tabbber li {
  background: #004aad;
}
.right_cont
  .right_banner_banner_cnt
  .my_account_inner
  .profile_tabbber
  li
  .nav-link {
  width: 100%;
  display: block;
  font-weight: 600;
}
.right_cont
  .right_banner_banner_cnt
  .my_account_inner
  .profile_tabbber
  li
  .nav-link.active {
  font-weight: 600;
}

.pay_with_card {
  margin-top: 40px;
}

.paywith_card {
  border: 1px solid #004aad;
  border-radius: 10px;
  padding: 30px 20px;
  position: relative;
}

.paywith_card h5 {
  font-size: 17px;
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  color: #004aad;
  display: inline-block;
  padding: 0 20px;
  margin-bottom: 0px;
  background: #fff;
}

.prf_inner_pay .prf_pay {
  height: 45px;
  border: 1px solid #004aad;
  border-radius: 6px;
  font-size: 15px;
  color: #000;
}
.prf_inner_pay .prf_pay:hover,
.prf_inner_pay .prf_pay:focus {
  box-shadow: none;
  outline: 0px;
}

.prf_inner_pay .prf_pay::placeholder {
  font-size: 15px;
}
.prf_inner_pay {
  position: relative;
  margin-bottom: 35px;
}

.prf_inner_pay label {
  font-weight: 600;
  font-size: 16px;
}

.prf_submi_button {
  /* display: block; */
  width: 40%;
  /* background: #004aad; */
  height: 45px;
  padding: 0px 30px;
  line-height: 45px;
  border: 0px;
  box-shadow: none;
  font-weight: 600;
  font-size: 16px;
}

.change_pass_section {
  margin-top: 40px;
}

.save_card {
  background-color: #efeeee;
  width: 100%;
  height: 80px;
  margin: 10px auto;
  max-width: 600px;
  border: 2px solid #7a7979;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 20px;
}

.save_card.active {
  border-color: #004aad;
}

.card_number {
  margin-bottom: 5px;
  font-size: 20px;
  font-weight: 600;
  line-height: 20px;
}

.card_exp p span {
  font-size: 18px;
  font-weight: 600;
  display: inline-block;
  margin-left: 10px;
}

.card_name div {
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 600;
}
.default_card {
  margin-top: -15px;
}

.card_name [type="radio"]:checked,
.card_name [type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
.card_name [type="radio"]:checked + label,
.card_name [type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #666;
}
.card_name [type="radio"]:checked + label:before,
.card_name [type="radio"]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #ddd;
  border-radius: 100%;
  background: #fff;
}
.card_name [type="radio"]:checked + label:after,
.card_name [type="radio"]:not(:checked) + label:after {
  content: "";
  width: 12px;
  height: 12px;
  background: #004aad;
  position: absolute;
  top: 3px;
  left: 3px;
  border-radius: 100%;
  transition: all 0.2s ease;
}
.card_name [type="radio"]:not(:checked) + label:after {
  opacity: 0;
  transform: scale(0);
}
.card_name [type="radio"]:checked + label:after {
  opacity: 1;
  transform: scale(1);
}

.add_new_card .prf_submi_button {
  display: inline-block;
  width: auto;
  padding: 0px 30px;
}

@media screen and (max-width: 767px) {
  .my_account_inner h2 {
    font-size: 20px;
  }
  .paywith_card h5 {
    font-size: 14px;
    padding: 0 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/my-account/my-account.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;AACA;;;;;;EAME,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;AACA;;;;;;EAME,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;;EAEE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EAEnB,yBAAyB;AAC3B;AACA;EACE,UAAU;EAEV,mBAAmB;AACrB;AACA;EACE,UAAU;EAEV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;EACjB;AACF","sourcesContent":[".my_account_inner {\n  background: #fff;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  max-width: 800px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 20px;\n  margin-bottom: 40px;\n}\n\n.my_account_inner h2 {\n  text-align: center;\n  font-size: 28px;\n  font-weight: 600;\n  color: #000;\n  margin-bottom: 0px;\n}\n\n.my_account_form {\n  margin-top: 40px;\n}\n\n.accnt_form label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #000;\n}\n.accnt_form .accnt_field {\n  height: 45px;\n  border-radius: 6px;\n  border: 1px solid #004aad;\n  font-size: 14px;\n}\n\n.accnt_form .accnt_field:focus {\n  outline: 0px;\n  box-shadow: none;\n}\n\n.accnt_form .accnt_field::placeholder {\n  font-size: 14px;\n}\n\n.accnt__bg .accnt_field {\n  background: #e7e6e6;\n}\n\n.accnt_submitt {\n  display: block;\n  width: 100%;\n  background: #004aad;\n  border-radius: 6px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  height: 45px;\n  line-height: 45px;\n  padding: 0;\n}\n\n.right_cont .right_banner_banner_cnt .my_account_inner .profile_tabbber li {\n  background: #004aad;\n}\n.right_cont\n  .right_banner_banner_cnt\n  .my_account_inner\n  .profile_tabbber\n  li\n  .nav-link {\n  width: 100%;\n  display: block;\n  font-weight: 600;\n}\n.right_cont\n  .right_banner_banner_cnt\n  .my_account_inner\n  .profile_tabbber\n  li\n  .nav-link.active {\n  font-weight: 600;\n}\n\n.pay_with_card {\n  margin-top: 40px;\n}\n\n.paywith_card {\n  border: 1px solid #004aad;\n  border-radius: 10px;\n  padding: 30px 20px;\n  position: relative;\n}\n\n.paywith_card h5 {\n  font-size: 17px;\n  position: absolute;\n  top: -14px;\n  left: 50%;\n  transform: translateX(-50%);\n  color: #004aad;\n  display: inline-block;\n  padding: 0 20px;\n  margin-bottom: 0px;\n  background: #fff;\n}\n\n.prf_inner_pay .prf_pay {\n  height: 45px;\n  border: 1px solid #004aad;\n  border-radius: 6px;\n  font-size: 15px;\n  color: #000;\n}\n.prf_inner_pay .prf_pay:hover,\n.prf_inner_pay .prf_pay:focus {\n  box-shadow: none;\n  outline: 0px;\n}\n\n.prf_inner_pay .prf_pay::placeholder {\n  font-size: 15px;\n}\n.prf_inner_pay {\n  position: relative;\n  margin-bottom: 35px;\n}\n\n.prf_inner_pay label {\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.prf_submi_button {\n  /* display: block; */\n  width: 40%;\n  /* background: #004aad; */\n  height: 45px;\n  padding: 0px 30px;\n  line-height: 45px;\n  border: 0px;\n  box-shadow: none;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.change_pass_section {\n  margin-top: 40px;\n}\n\n.save_card {\n  background-color: #efeeee;\n  width: 100%;\n  height: 80px;\n  margin: 10px auto;\n  max-width: 600px;\n  border: 2px solid #7a7979;\n  border-radius: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 30px 20px;\n}\n\n.save_card.active {\n  border-color: #004aad;\n}\n\n.card_number {\n  margin-bottom: 5px;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.card_exp p span {\n  font-size: 18px;\n  font-weight: 600;\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.card_name div {\n  text-transform: uppercase;\n  font-size: 20px;\n  font-weight: 600;\n}\n.default_card {\n  margin-top: -15px;\n}\n\n.card_name [type=\"radio\"]:checked,\n.card_name [type=\"radio\"]:not(:checked) {\n  position: absolute;\n  left: -9999px;\n}\n.card_name [type=\"radio\"]:checked + label,\n.card_name [type=\"radio\"]:not(:checked) + label {\n  position: relative;\n  padding-left: 28px;\n  cursor: pointer;\n  line-height: 20px;\n  display: inline-block;\n  color: #666;\n}\n.card_name [type=\"radio\"]:checked + label:before,\n.card_name [type=\"radio\"]:not(:checked) + label:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 18px;\n  height: 18px;\n  border: 1px solid #ddd;\n  border-radius: 100%;\n  background: #fff;\n}\n.card_name [type=\"radio\"]:checked + label:after,\n.card_name [type=\"radio\"]:not(:checked) + label:after {\n  content: \"\";\n  width: 12px;\n  height: 12px;\n  background: #004aad;\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  border-radius: 100%;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.card_name [type=\"radio\"]:not(:checked) + label:after {\n  opacity: 0;\n  -webkit-transform: scale(0);\n  transform: scale(0);\n}\n.card_name [type=\"radio\"]:checked + label:after {\n  opacity: 1;\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n\n.add_new_card .prf_submi_button {\n  display: inline-block;\n  width: auto;\n  padding: 0px 30px;\n}\n\n@media screen and (max-width: 767px) {\n  .my_account_inner h2 {\n    font-size: 20px;\n  }\n  .paywith_card h5 {\n    font-size: 14px;\n    padding: 0 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
